import React from 'react';
import { CheckCircle, Clock, TrendingUp, DollarSign, Heart } from 'lucide-react';
export function WhyChoose() {
  const benefits = [{
    icon: CheckCircle,
    title: 'Trained Support Agents',
    description: 'Our team undergoes rigorous training to master your product and brand voice.'
  }, {
    icon: Clock,
    title: 'Fast Response Times',
    description: 'We prioritize speed without sacrificing quality to ensure high customer satisfaction.'
  }, {
    icon: TrendingUp,
    title: 'Scalable Solutions',
    description: 'Easily scale your support team up or down based on seasonal demand.'
  }, {
    icon: DollarSign,
    title: 'Cost-Effective',
    description: 'Save on overhead costs like hiring, training, and infrastructure.'
  }, {
    icon: Heart,
    title: 'Customer-Focused',
    description: 'We treat your customers with the same care and respect that you would.'
  }];
  return <section id="why-us" className="py-20 bg-white overflow-hidden" data-id="element-192">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-193">
        <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-194">
          <div className="flex-1" data-id="element-195">
            <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl mb-6" data-id="element-196">
              Why Choose AMK Solutions?
            </h2>
            <p className="text-lg text-slate-600 mb-10" data-id="element-197">
              Partnering with us means more than just outsourcing; it means
              gaining a strategic partner committed to your growth.
            </p>

            <div className="space-y-6" data-id="element-198">
              {benefits.map((benefit, index) => <div key={index} className="flex gap-4" data-id="element-199">
                  <div className="flex-shrink-0 mt-1" data-id="element-200">
                    <benefit.icon className="h-6 w-6 text-blue-600" data-id="element-201" />
                  </div>
                  <div data-id="element-202">
                    <h3 className="text-lg font-semibold text-slate-900" data-id="element-203">
                      {benefit.title}
                    </h3>
                    <p className="text-slate-600 mt-1" data-id="element-204">{benefit.description}</p>
                  </div>
                </div>)}
            </div>
          </div>

          <div className="flex-1 w-full relative" data-id="element-205">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl bg-slate-900 aspect-square sm:aspect-[4/3] lg:aspect-square" data-id="element-206">
              {/* Abstract decorative elements representing efficiency/growth */}
              <div className="absolute inset-0 bg-gradient-to-br from-slate-800 to-slate-900" data-id="element-207"></div>
              <div className="absolute inset-0 opacity-20" style={{
              backgroundImage: 'radial-gradient(#4f46e5 1px, transparent 1px)',
              backgroundSize: '24px 24px'
            }} data-id="element-208"></div>

              <div className="absolute inset-0 flex items-center justify-center" data-id="element-209">
                <div className="w-3/4 h-3/4 bg-white/5 backdrop-blur-sm rounded-xl border border-white/10 p-8 flex flex-col justify-between" data-id="element-210">
                  <div className="flex justify-between items-start" data-id="element-211">
                    <div data-id="element-212">
                      <div className="text-4xl font-bold text-white mb-1" data-id="element-213">
                        98%
                      </div>
                      <div className="text-slate-400 text-sm" data-id="element-214">CSAT Score</div>
                    </div>
                    <div className="h-10 w-10 rounded-full bg-green-500/20 flex items-center justify-center" data-id="element-215">
                      <TrendingUp className="h-5 w-5 text-green-400" data-id="element-216" />
                    </div>
                  </div>

                  <div className="space-y-4" data-id="element-217">
                    <div className="h-2 bg-slate-700 rounded-full overflow-hidden" data-id="element-218">
                      <div className="h-full w-[98%] bg-blue-500 rounded-full" data-id="element-219"></div>
                    </div>
                    <div className="h-2 bg-slate-700 rounded-full overflow-hidden" data-id="element-220">
                      <div className="h-full w-[92%] bg-purple-500 rounded-full" data-id="element-221"></div>
                    </div>
                    <div className="h-2 bg-slate-700 rounded-full overflow-hidden" data-id="element-222">
                      <div className="h-full w-[95%] bg-emerald-500 rounded-full" data-id="element-223"></div>
                    </div>
                  </div>

                  <div className="flex justify-between items-end" data-id="element-224">
                    <div data-id="element-225">
                      <div className="text-3xl font-bold text-white mb-1" data-id="element-226">
                        &lt; 1m
                      </div>
                      <div className="text-slate-400 text-sm" data-id="element-227">
                        Response Time
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}